export enum PortType {
  Input = 'input',
  Output = 'output',
}
